import { render } from "./TabDesc.vue?vue&type=template&id=2a6620c4"
import script from "./TabDesc.vue?vue&type=script&lang=js"
export * from "./TabDesc.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__